/* Added by MORYARTY - Store locator Mapbox init (MOD-015) */
(function () {
  'use strict';

  var dataEl = document.getElementById('store-locator-data');
  var configEl = document.getElementById('store-locator-config');
  var mapEl = document.getElementById('store-locator-map');
  if (!dataEl || !configEl || !mapEl || typeof mapboxgl === 'undefined') return;

  var locations, config;
  try {
    locations = JSON.parse(dataEl.textContent);
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    console.error('[store-locator] Invalid JSON in data/config block', e);
    return;
  }

  if (!Array.isArray(locations) || locations.length === 0) return;
  if (!config.token) {
    console.warn('[store-locator] Mapbox token missing — set in theme settings.');
    return;
  }

  locations = locations
    .map(function (loc) {
      var lat = parseFloat(loc.latitude);
      var lng = parseFloat(loc.longitude);
      if (Number.isNaN(lat) || Number.isNaN(lng)) return null;
      return Object.assign({}, loc, { latitude: lat, longitude: lng });
    })
    .filter(Boolean);

  if (locations.length === 0) {
    console.warn('[store-locator] No locations have valid lat/lng.');
    return;
  }

  mapboxgl.accessToken = config.token;

  var bounds = new mapboxgl.LngLatBounds();
  locations.forEach(function (loc) {
    bounds.extend([loc.longitude, loc.latitude]);
  });

  var map = new mapboxgl.Map({
    container: 'store-locator-map',
    style: config.style || 'mapbox://styles/mapbox/streets-v12',
    bounds: bounds,
    fitBoundsOptions: { padding: 60, maxZoom: 11 }
  });

  map.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'top-right');

  var geolocate = new mapboxgl.GeolocateControl({
    positionOptions: { enableHighAccuracy: true },
    trackUserLocation: false,
    showAccuracyCircle: false
  });
  map.addControl(geolocate);

  // Hide Mapbox's default geolocate button — we trigger it from our own UI button above the map.
  map.on('load', function () {
    var defaultBtn = mapEl.querySelector('.mapboxgl-ctrl-geolocate');
    if (defaultBtn && defaultBtn.parentElement) {
      defaultBtn.parentElement.style.display = 'none';
    }
  });

  var geolocateBtn = document.getElementById('store-locator-geolocate');
  if (geolocateBtn) {
    geolocateBtn.addEventListener('click', function () {
      geolocate.trigger();
    });
  }

  geolocate.on('geolocate', function (e) {
    sortListByDistance(e.coords.longitude, e.coords.latitude);
  });

  var markersById = new Map();

  locations.forEach(function (loc) {
    var el = document.createElement('div');
    el.className = 'store-locator__map-marker';
    if (loc.type === 'retailer') el.classList.add('store-locator__map-marker--retailer');
    el.textContent = (loc.name || '?').charAt(0).toUpperCase();
    el.setAttribute('aria-label', loc.name || 'Location');
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');

    var popupHtml =
      '<strong>' + escapeHtml(loc.name) + '</strong>' +
      escapeHtml(loc.address_line_1);
    if (loc.address_line_2) popupHtml += '<br>' + escapeHtml(loc.address_line_2);
    popupHtml += '<br>' + escapeHtml(loc.city) + ' ' + escapeHtml(loc.postal_code);
    popupHtml += '<br>' + escapeHtml(loc.country);
    var popupLinks = [];
    if (loc.google_map_url) {
      popupLinks.push('<a href="' + escapeHtml(loc.google_map_url) + '" target="_blank" rel="noopener">View on map</a>');
    }
    if (loc.website) {
      popupLinks.push('<a href="' + escapeHtml(loc.website) + '" target="_blank" rel="noopener">Website</a>');
    }
    if (popupLinks.length) {
      popupHtml += '<div class="store-locator__popup-links">' + popupLinks.join(' &middot; ') + '</div>';
    }

    var popup = new mapboxgl.Popup({ offset: 18, closeButton: false }).setHTML(popupHtml);

    var marker = new mapboxgl.Marker({ element: el })
      .setLngLat([loc.longitude, loc.latitude])
      .setPopup(popup)
      .addTo(map);

    el.addEventListener('click', function () {
      highlightCard(loc.id);
    });

    markersById.set(loc.id, marker);
  });

  var geocoderContainer = document.getElementById('store-locator-geocoder');
  if (geocoderContainer && typeof MapboxGeocoder !== 'undefined') {
    var geocoder = new MapboxGeocoder({
      accessToken: config.token,
      mapboxgl: mapboxgl,
      marker: false,
      placeholder: 'Type a postcode or address…',
      flyTo: { speed: 1.2, zoom: 11 }
    });
    geocoderContainer.appendChild(geocoder.onAdd(map));

    geocoder.on('result', function (e) {
      var coords = e.result && e.result.geometry && e.result.geometry.coordinates;
      if (!coords) return;
      sortListByDistance(coords[0], coords[1]);
    });

    geocoder.on('clear', restoreOriginalListOrder);
  }

  document.querySelectorAll('[data-store-locator-card]').forEach(function (cardBtn) {
    cardBtn.addEventListener('click', function () {
      var item = cardBtn.closest('[data-store-locator-item]');
      if (!item) return;
      var id = parseInt(item.dataset.locationId, 10);
      var marker = markersById.get(id);
      var loc = locations.find(function (l) { return l.id === id; });
      if (!marker || !loc) return;
      map.flyTo({ center: [loc.longitude, loc.latitude], zoom: 14, speed: 1.2 });
      // Re-open popup if closed; toggling once when already open would close it, so always re-show.
      marker.getPopup().addTo(map);
      highlightCard(id);
    });
  });

  function sortListByDistance(refLng, refLat) {
    document.querySelectorAll('.store-locator__list').forEach(function (ul) {
      var items = Array.from(ul.children);
      items.sort(function (a, b) {
        var ida = parseInt(a.dataset.locationId, 10);
        var idb = parseInt(b.dataset.locationId, 10);
        var la = locations.find(function (l) { return l.id === ida; });
        var lb = locations.find(function (l) { return l.id === idb; });
        if (!la || !lb) return 0;
        return haversine(refLat, refLng, la.latitude, la.longitude) -
               haversine(refLat, refLng, lb.latitude, lb.longitude);
      });
      items.forEach(function (item) { ul.appendChild(item); });
    });
  }

  function restoreOriginalListOrder() {
    document.querySelectorAll('.store-locator__list').forEach(function (ul) {
      var items = Array.from(ul.children);
      items.sort(function (a, b) {
        return parseInt(a.dataset.locationId, 10) - parseInt(b.dataset.locationId, 10);
      });
      items.forEach(function (item) { ul.appendChild(item); });
    });
  }

  function highlightCard(id) {
    document.querySelectorAll('.store-locator__item--active').forEach(function (el) {
      el.classList.remove('store-locator__item--active');
    });
    var target = document.querySelector('[data-store-locator-item][data-location-id="' + id + '"]');
    if (target) {
      target.classList.add('store-locator__item--active');
      target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  // Great-circle distance in kilometers (haversine formula).
  function haversine(lat1, lng1, lat2, lng2) {
    var R = 6371;
    var toRad = function (d) { return d * Math.PI / 180; };
    var dLat = toRad(lat2 - lat1);
    var dLng = toRad(lng2 - lng1);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
            Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.asin(Math.sqrt(a));
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
})();
